/* MIcase · buscador de modelo — comportamiento. Extraido de
   snippets/micase-buscador-modelo.liquid el 2026-08-16 para sacarlo del HTML de cada
   ficha. Contenido identico, sin una linea de Liquid. Se carga con defer: la guarda
   customElements.get() de abajo hace que cargarlo dos veces no rompa nada, y el upgrade
   del navegador alcanza a los elementos ya presentes en el DOM. */

if (!customElements.get('micase-buscador-modelo')) {
  customElements.define('micase-buscador-modelo', class extends HTMLElement {
    connectedCallback() {
      /* El script se ejecuta justo despues de este elemento, y el fieldset con los radios
         de Dawn se pinta DESPUES. En la primera carga, al hacer upgrade el elemento, los
         radios todavia no existen. Por eso la puesta en marcha se aplaza a que el
         documento este listo. Al repintar la variante el documento ya esta completo y el
         nodo nuevo llega con sus hermanos, asi que arranca en el acto. */
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.iniciar.bind(this), { once: true });
      } else {
        this.iniciar();
      }
    }

    iniciar() {
      if (this.mcListo) return;
      this.mcListo = true;
      this.opcion = this.dataset.opcion;
      this.campo = this.querySelector('.mcbm__campo');
      this.panel = this.querySelector('.mcbm__panel');
      this.limpiar = this.querySelector('.mcbm__limpiar');
      this.vs = this.closest('variant-selects');
      if (!this.vs || !this.campo) {
        this.rendirse('no hay variant-selects alrededor, o falta el campo de texto');
        return;
      }

      /* COMO SE LOCALIZA EL CONTROL NATIVO. Reescrito el 2026-08-10.
         EL FALLO QUE SE ARREGLA: antes solo existia el camino 2 y TODA la ocultacion
         colgaba de el. Si no aparecian radios, el codigo se rendia y el fieldset no
         recibia nunca la clase mcbm-oculto, o sea que los treinta y tantos botones se
         quedaban a la vista. Y como rendirse tampoco escondia el buscador (ver
         .mcbm[hidden] en el CSS de arriba), se veian las dos cosas a la vez, que es
         exactamente lo que se midio en la ficha del MagSafe Matte. Ahora hay tres
         caminos y el primero no depende de nada que el tema pueda dejar de escribir. */

      /* 1. EL FIELDSET QUE MARCA EL SERVIDOR, en snippets/product-variant-picker.liquid.
            El mismo bloque de Liquid que decide renderizar este buscador escribe
            data-mcbm-nativo en el fieldset: o estan los dos, o no esta ninguno. */
      this.grupo =
        this.vs.querySelector('fieldset[data-mcbm-nativo="' + this.attrEsc(this.opcion) + '"]') ||
        this.vs.querySelector('fieldset[data-mcbm-nativo]');
      this.radios = this.grupo
        ? Array.from(this.grupo.querySelectorAll('input[type="radio"]'))
        : [];

      /* 2. RESPALDO: data-option-name. Dawn 15 lo escribe en
            snippets/product-variant-options.liquid y lo lee el propio Dawn en
            VariantSelects.getAllSelectedOptions, asi que es fiable, pero es un atributo de
            una version concreta del tema y este snippet se copia y se recopia entre temas.
            Se queda como red, no como camino principal. */
      if (!this.radios.length) {
        this.radios = Array.from(
          this.vs.querySelectorAll('input[type="radio"][data-option-name="' + this.attrEsc(this.opcion) + '"]')
        );
        if (this.radios.length) this.grupo = this.radios[0].closest('fieldset');
      }

      /* 3. ULTIMO RESPALDO: el atributo name, que Dawn compone como
            "<NombreDeLaOpcion>-<posicion>" (input_name en product-variant-options.liquid).
            Es lo mas dificil de perder que hay, porque de ese name depende que los radios
            sean un mismo grupo de seleccion: si cambia, se rompe el selector entero y se
            nota al instante. */
      if (!this.radios.length) {
        var pref = String(this.opcion || '') + '-';
        var todos = this.vs.querySelectorAll('fieldset input[type="radio"]');
        var hallados = [];
        for (var t = 0; t < todos.length; t++) {
          if ((todos[t].getAttribute('name') || '').indexOf(pref) === 0) hallados.push(todos[t]);
        }
        this.radios = hallados;
        if (this.radios.length) this.grupo = this.radios[0].closest('fieldset');
      }

      if (!this.radios.length || !this.grupo) {
        /* Si la opcion se llama distinto en este producto, el buscador no se inventa nada:
           se quita de en medio y deja el selector de Dawn a la vista. Mejor sin buscador
           que con un buscador que no encuentra. */
        this.rendirse('no se encontraron los radios de la opcion "' + (this.opcion || '') + '"');
        return;
      }

      /* Se esconde SOLO este fieldset, el de la opcion Modelo. El de Color no se toca.
         Y se esconde AQUI, ya con los radios en la mano: si algo hubiera fallado, el
         cliente se queda con el control nativo, que es feo pero vende. Nunca al reves. */
      this.grupo.classList.add('mcbm-oculto');

      this.items = this.radios.map((r) => {
        var et = this.vs.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(r.id) : r.id) + '"]');
        var txt = (et ? et.textContent : r.value) || '';
        return {
          radio: r,
          texto: (r.value || txt).trim(),
          clave: this.norm(r.value || txt),
          /* Clave sin espacios: es lo que hace que "note13" encuentre "Redmi Note 13".
             Mucha gente escribe el modelo pegado, y esa no es una falta que deba costar
             una venta. Se compara contra las dos claves, la normal y la compacta. */
          compacta: this.norm(r.value || txt).replace(/ /g, ''),
          agotado: r.classList.contains('disabled'),
          elegido: r.checked
        };
      });

      var elegido = this.items.find(function (i) { return i.elegido; });
      if (elegido) this.campo.value = elegido.texto;

      this.campo.addEventListener('input', this.alEscribir.bind(this));
      this.campo.addEventListener('focus', this.alEnfocar.bind(this));
      this.campo.addEventListener('keydown', this.alTeclear.bind(this));
      this.limpiar.addEventListener('click', this.alLimpiar.bind(this));
      this.panel.addEventListener('click', this.alPulsar.bind(this));
      this.fuera = this.alPulsarFuera.bind(this);
      document.addEventListener('pointerdown', this.fuera);
    }

    disconnectedCallback() {
      document.removeEventListener('pointerdown', this.fuera);
    }

    /* Apartarse sin romper nada: el buscador desaparece y el selector nativo de Dawn se
       queda a la vista, intacto. El atributo data-mcbm-fallo se deja puesto para que en
       una revision futura se pueda ver desde el DOM que esto paso y por que. */
    rendirse(motivo) {
      this.hidden = true;
      this.setAttribute('data-mcbm-fallo', motivo || 'sin detalle');
      try {
        console.warn('[MIcase] buscador de modelo: ' + (motivo || '') +
          '. Se deja el selector nativo de Dawn a la vista.');
      } catch (e) {}
    }

    /* Escapado para un selector de atributo CSS. Lo que habia antes convertia la comilla
       en &quot;, que es escapado de HTML y en un selector no sirve de nada: el DOM guarda
       el valor ya descodificado. Se escapa como manda CSS, con barra invertida. */
    attrEsc(s) { return String(s == null ? '' : s).replace(/\\/g, '\\\\').replace(/"/g, '\\"'); }

    /* El normalizador canonico de MIcase, el mismo que usa el resto del sitio, para que
       "note13", "Note 13" y "REDMI NOTE 13" encuentren lo mismo. Si por lo que sea no
       estuviera cargado, hay un respaldo equivalente aqui abajo. */
    norm(s) {
      if (window.MCModelo && typeof window.MCModelo.norm === 'function') {
        return window.MCModelo.norm(s);
      }
      return String(s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[^a-z0-9+]+/g, ' ')
        .replace(/\+/g, ' plus ')
        .replace(/\s+/g, ' ')
        .trim();
    }

    alEnfocar() { this.pinta(''); }

    alEscribir() {
      this.limpiar.hidden = !this.campo.value;
      this.pinta(this.campo.value);
    }

    alLimpiar() {
      this.campo.value = '';
      this.limpiar.hidden = true;
      this.campo.focus();
      this.pinta('');
    }

    alPulsarFuera(e) {
      if (!this.contains(e.target)) this.cierra();
    }

    cierra() {
      this.panel.hidden = true;
      this.campo.setAttribute('aria-expanded', 'false');
    }

    pinta(consulta) {
      var q = this.norm(consulta);
      var lista = this.items;
      if (q) {
        /* Primero los que empiezan por lo tecleado, despues los que lo contienen.
           Con 102 modelos, "note 13" tiene que dar el Note 13 arriba, no el Note 13 Pro. */
        var qc = q.replace(/ /g, '');
        var empieza = [], contiene = [];
        for (var i = 0; i < lista.length; i++) {
          var c = lista[i].clave, cc = lista[i].compacta;
          if (c.indexOf(q) === 0 || cc.indexOf(qc) === 0) empieza.push(lista[i]);
          else if (c.indexOf(q) > -1 || cc.indexOf(qc) > -1) contiene.push(lista[i]);
        }
        /* Dentro de cada grupo, primero el nombre mas corto. Con "note 13" el cliente
           casi siempre busca el Note 13 a secas, no el Note 13 Pro Plus. */
        var porLargo = function (a, b) { return a.clave.length - b.clave.length; };
        empieza.sort(porLargo);
        contiene.sort(porLargo);
        lista = empieza.concat(contiene);

        if (!lista.length) {
          /* Nadie escribe perfecto en un celular. Si la busqueda estricta no da nada,
             se prueba en modo indulgente: que las letras aparezcan EN ORDEN aunque falte
             alguna. Asi "nte 13" encuentra "Note 13". Es la diferencia entre perder la
             venta y no perderla. */
          var sub = [];
          for (var k = 0; k < this.items.length; k++) {
            if (this.contieneEnOrden(this.items[k].compacta, qc)) sub.push(this.items[k]);
          }
          sub.sort(porLargo);
          lista = sub;
        }
      }

      if (!lista.length) {
        this.panel.innerHTML = '<p class="mcbm__vacio">No encontramos ese modelo. Prueba escribiendo solo el numero, o mira si esta en la lista completa.</p>';
      } else {
        var html = '';
        for (var j = 0; j < lista.length; j++) {
          var it = lista[j];
          html += '<button type="button" class="mcbm__it" role="option" data-i="' + this.items.indexOf(it) + '"'
            + (it.agotado ? ' data-agotado' : '')
            + (it.elegido ? ' data-elegido aria-selected="true"' : ' aria-selected="false"')
            + '><span>' + this.resalta(it.texto, consulta) + '</span>'
            + (it.agotado ? '<span class="mcbm__eti">Agotado</span>' : '')
            + '</button>';
        }
        this.panel.innerHTML = html;
      }
      this.panel.hidden = false;
      this.campo.setAttribute('aria-expanded', 'true');
      this.activo = -1;
    }

    contieneEnOrden(clave, q) {
      if (!q) return true;
      var i = 0;
      for (var j = 0; j < clave.length && i < q.length; j++) {
        if (clave[j] === q[i]) i++;
      }
      return i === q.length;
    }

    resalta(texto, consulta) {
      var esc = texto.replace(/[<>&]/g, function (c) { return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]; });
      var q = (consulta || '').trim();
      if (!q) return esc;
      var i = this.norm(texto).indexOf(this.norm(q));
      if (i < 0) return esc;
      /* La posicion se calcula sobre la clave normalizada, asi que sobre el texto original
         solo se resalta si coinciden en longitud. Si no, se deja sin resaltar antes que
         resaltar el trozo equivocado. */
      if (this.norm(texto).length !== texto.length) return esc;
      return esc.slice(0, i) + '<mark>' + esc.slice(i, i + q.length) + '</mark>' + esc.slice(i + q.length);
    }

    alTeclear(e) {
      var botones = this.panel.querySelectorAll('.mcbm__it');
      if (e.key === 'Escape') { this.cierra(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (this.panel.hidden) this.pinta(this.campo.value);
        if (!botones.length) return;
        this.activo = e.key === 'ArrowDown'
          ? Math.min((this.activo === undefined ? -1 : this.activo) + 1, botones.length - 1)
          : Math.max((this.activo === undefined ? 0 : this.activo) - 1, 0);
        for (var i = 0; i < botones.length; i++) botones[i].removeAttribute('data-activo');
        botones[this.activo].setAttribute('data-activo', '');
        botones[this.activo].scrollIntoView({ block: 'nearest' });
        return;
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        var b = (this.activo >= 0 && botones[this.activo]) ? botones[this.activo] : botones[0];
        if (b) this.elige(+b.dataset.i);
      }
    }

    alPulsar(e) {
      var b = e.target.closest('.mcbm__it');
      if (b) this.elige(+b.dataset.i);
    }

    elige(i) {
      var it = this.items[i];
      if (!it) return;
      this.campo.value = it.texto;
      this.cierra();
      /* Aqui esta todo el truco: se marca el control NATIVO y se dispara SU evento.
         El resto (calcular la variante, escribir input[name="id"], repintar precio,
         galeria y disponibilidad) lo hace Dawn. Nosotros no decidimos nada. */
      it.radio.checked = true;
      it.radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}
